export default __webpack_public_path__ + "static/media/Level25.aaff43af.svg";